module.exports = __webpack_public_path__ + "static/fabpaintsbrush-1b7b28ecf6d05bc08c21b9019cd44709.png";